export enum dayjsUnits {
  DAY = "day",
  WEEK = "w",
  MONTH = "M",
  YEAR = "y"
}